import { UserOutlined } from "@ant-design/icons";
import {
  Avatar,
  Button,
  DatePicker,
  Flex,
  Input,
  Radio,
  Space,
  Typography,
  theme,
} from "antd";
import dayjs from "dayjs";
import { deepCopy } from "../../utils/deepCopy";
const { Text, Title, Link } = Typography;
const { useToken } = theme;

export function AccountSetupProfile({
  steps,
  currentStep,
  setCurrentStep,

  metadata,
  setMetadata,
}: {
  steps: number;
  currentStep: number;
  setCurrentStep: (data: number) => void;

  metadata: { [key: string]: any };
  setMetadata: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
}) {
  const { token } = useToken();

  return (
    <Flex
      style={{
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Flex
        style={{
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "320px",
        }}
      >
        <Avatar
          shape="square"
          src={metadata.avatar}
          size={64}
          icon={<UserOutlined />}
        />

        <Text
          style={{
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            marginBottom: token.marginMD,
            fontSize: token.fontSizeHeading3,
            marginTop: "10px",
          }}
        >
          Complete your profile
        </Text>

        {/* Content */}

        <Space>
          <Input
            size="large"
            placeholder="First name"
            value={metadata.name}
            onChange={(event) =>
              setMetadata((prevState) => {
                const copy = deepCopy(prevState);

                copy.name = event.target.value;

                return copy;
              })
            }
          />
          <Input
            size="large"
            placeholder="Last name"
            value={metadata.lastName}
            onChange={(event) =>
              setMetadata((prevState) => {
                const copy = deepCopy(prevState);

                copy.lastName = event.target.value;

                return copy;
              })
            }
          />
        </Space>

        <DatePicker
          size="large"
          style={{
            width: "100%",
            marginTop: token.marginMD,
            borderRadius: token.borderRadiusLG,
          }}
          placeholder="Your birthday"
          value={metadata.birthday ? dayjs(metadata.birthday) : undefined}
          onChange={(date) => {
            setMetadata((prevState) => {
              const copy = deepCopy(prevState);

              if (date) {
                copy.birthday = dayjs(date).format("YYYY-MM-DD");
              } else {
                copy.birthday = undefined;
              }

              return copy;
            });
          }}
        />

        <Text
          style={{
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            marginBottom: token.marginMD,
            fontSize: token.fontSizeHeading4,
            marginTop: token.marginLG,
          }}
        >
          Complete your profile
        </Text>

        <Radio.Group
          value={metadata.gender}
          onChange={(event) => {
            setMetadata((prevState) => {
              const copy = deepCopy(prevState);

              copy.gender = event.target.value;

              return copy;
            });
          }}
        >
          <Radio defaultChecked value="female">
            Female
          </Radio>
          <Radio value="male">Male</Radio>
          <Radio value="">Specify another</Radio>
        </Radio.Group>

        {metadata.gender != "female" && metadata.gender != "male" && (
          <Input
            size="large"
            placeholder="Enter your name"
            value={metadata.gender}
            style={{ marginTop: token.marginSM }}
            onChange={(event) =>
              setMetadata((prevState) => {
                const copy = deepCopy(prevState);

                copy.gender = event.target.value;

                return copy;
              })
            }
          />
        )}

        {/* EndContent */}

        <Button
          style={{
            margin: token.marginMD,
            padding: token.paddingContentVerticalLG,
            width: "320px",
            marginTop: token.marginXXL + token.marginXL,
          }}
          type="primary"
          onClick={() => {
            setCurrentStep(currentStep + 1);
          }}
        >
          <Text style={{ color: token.Button?.primaryColor }}>Next</Text>
        </Button>

        <Flex align="center" justify="space-between" style={{ width: "100%" }}>
          {/* <Button
          type="link"
          style={{ padding: 0 }}
          onClick={() => {
            setCurrentStep(currentStep + 1);
          }}
        >
          <Text style={{ textAlign: "left" }}>Skip</Text>
        </Button> */}
          <div />

          <Flex align="center">
            {Array.from({ length: steps }).map((_, index) => {
              if (index > currentStep) {
                return (
                  <Button
                    key={index}
                    size="small"
                    style={{
                      background: "transparent",
                      border: "none",
                      boxShadow: "none",
                    }}
                    onClick={() => setCurrentStep(index)}
                  >
                    <div
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: token.colorBgContainer,
                        border: `1px solid ${token.colorSplit}`,
                      }}
                    />
                  </Button>
                );
              }

              return (
                <Button
                  key={index}
                  size="small"
                  style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                  }}
                  onClick={() => setCurrentStep(index)}
                >
                  <div
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: token.colorPrimary,
                    }}
                  />
                </Button>
              );
            })}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
